import { Form, ProgressBar } from "react-bootstrap";
import { FaVideo, FaUpload } from "react-icons/fa";

export const VideoInput = ({
  videoType,
  videoLink,
  videoFile,
  existingVideo = null,
  onVideoTypeChange,
  onVideoLinkChange,
  onVideoFileSelect,
  validationError,
  uploadProgress,
  uploadError,
  namePrefix = "video",
}) => {
  // display existing video info if available
  const existingVideoDisplay =
    existingVideo && existingVideo.type === "file"
      ? existingVideo.name || "Video file uploaded"
      : existingVideo?.url && existingVideo.type === "link"
      ? existingVideo.url
      : null;

  return (
    <div>
      <h6 className="d-flex align-items-center gap-2 mb-2">
        <FaVideo /> Video Description <span className="text-danger">*</span>
      </h6>
      {existingVideoDisplay && (
        <p className="small text-muted text-truncate" style={{ marginTop: "-8px" }}>
          Current: {existingVideoDisplay}
        </p>
      )}
      <div className="d-flex flex-row gap-2 ms-2">
        <div style={{ flex: 1, maxWidth: "50%" }}>
          <Form.Check
            type="radio"
            label="Video Link"
            name={`${namePrefix}-type`}
            id={`${namePrefix}-link`}
            checked={videoType === "link"}
            onChange={() => onVideoTypeChange("link")}
            className="mb-1"
          />
          {videoType === "link" && (
            <div>
              <Form.Control
                type="text"
                value={videoLink}
                onChange={(e) => onVideoLinkChange(e.target.value)}
                placeholder="Video URL"
                className={validationError ? "is-invalid" : ""}
              />
            </div>
          )}
        </div>
        <div style={{ flex: 1, maxWidth: "50%" }}>
          <Form.Check
            type="radio"
            label="Upload Video File"
            name={`${namePrefix}-type`}
            id={`${namePrefix}-file`}
            checked={videoType === "file"}
            onChange={() => onVideoTypeChange("file")}
            className="mb-1"
          />
          {videoType === "file" && (
            <div>
              <div
                className={`border border-2 rounded p-2 text-center bg-light ${
                  validationError ? "border-danger" : ""
                }`}
                style={{ borderStyle: "dashed", cursor: "pointer" }}
                onClick={() =>
                  document.getElementById(`${namePrefix}-file-upload`).click()
                }
              >
                <input
                  id={`${namePrefix}-file-upload`}
                  type="file"
                  accept="video/*"
                  onChange={onVideoFileSelect}
                  className="d-none"
                />
                <div className="d-flex flex-row gap-2 align-items-center justify-content-center">
                  <FaUpload
                    className="text-secondary"
                    style={{ fontSize: "20px" }}
                  />
                  <p className="mb-0 text-muted small text-truncate">
                    {videoFile
                      ? videoFile.name
                      : existingVideo && existingVideo.type === "file"
                      ? existingVideo.name || "Video file uploaded"
                      : "Click to upload video file"}
                  </p>
                </div>
                {uploadProgress > 0 && uploadProgress < 100 && (
                  <ProgressBar
                    now={uploadProgress}
                    className="mt-2"
                    style={{ height: "8px" }}
                    variant="primary"
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {uploadError && <p className="text-danger small mt-1">{uploadError}</p>}
      {validationError && (
        <p className="text-danger small mt-1">{validationError}</p>
      )}
    </div>
  );
};
